
import { useEffect, useState } from "react";
import { useAuthState } from "../../../../../Helper/Context/context";
import { useDispatch, useSelector } from "react-redux";
import { Loading } from "../../../../../Helper/LogoLoader/LogoLoader";
import KeepingplantsAdd from "../KeepingplantsAdd/KeepingplantsAdd";
import DeletePopUP from "../../../../CommonPopUp/DeletePopUp";
import { StatusOfIntercropsDDL } from "../../../../CommonDDL/StatusOfIntercropsDDL";
import StatusofintercropsPopup from "./StatusofintercropsPopup";
import { StatusOfIntercropsDeleteAPI, StatusOfIntercropsTableDataAPI } from "../../../../../Helper/Redux/AdminDashboardSlice/PlantationDetailsPartThirdSlice";
import { CommonCircle } from "../CommonCircle";
import { AstricSign } from "../../../../../Helper/AstricSign";


const StatusOfIntercrops = (props) => {

    const { M_BeneficiaryDetailsID, T_BeneficiaryPlantationDetailsID, StatusOfIntercropsId, setStatusOfIntercropsId, Flag, data, PlantdistancesId } = props

    const userDetails = useAuthState();
    const { UserID, token } = userDetails
    const dispatch = useDispatch()

    console.log("StatusOfIntercropsId",StatusOfIntercropsId.ID)

    const [IntercropsPopup, setIntercropsPopup] = useState(false)

    const [ShowDeletePopup, setShowDeletePopup] = useState(false)
    const [StatusInterCropsData, setStatusInterCropsData] = useState([])
    const [InterCropsDataIsPost, setInterCropsDataIsPost] = useState(false)
    const [IsOthersData, setIsOthersData] = useState(false)
    const [ShowDeletePopupData, setShowDeletePopupData] = useState({
        data: ''
    })


    const handleAddIntercrops = () => {
        setIntercropsPopup(!IntercropsPopup)
    }

    const handleShowDelete = (data) => {

        setShowDeletePopup(!ShowDeletePopup)
        { data && setShowDeletePopupData(data) }
    }
    const handleInterCropsDataIsPost = () => {
        setInterCropsDataIsPost(!InterCropsDataIsPost)
        handleShowDelete()
        setShowDeletePopup(false)
    }
   

    useEffect(() => {
        const data = {

            T_BeneficiaryPlantationDetailsID: T_BeneficiaryPlantationDetailsID,
            M_BeneficiaryDetailsID: M_BeneficiaryDetailsID,
            ReplaceCrop_M_IndicatorMasterID: StatusOfIntercropsId.ID,
            M_TableUserMasterID: UserID,
            Flag: "StatusInterCrops",
            token: token,
            setStatusInterCropsData: setStatusInterCropsData,
        }
        if(StatusOfIntercropsId.ID != undefined && StatusOfIntercropsId.ID != 0){
            dispatch(StatusOfIntercropsTableDataAPI({ data }))
        }
       
    }, [InterCropsDataIsPost,StatusOfIntercropsId.ID])

    const { isFirstPartLoading } = useSelector(state => state.StatusOfIntercropsTableData)


    const handleDeleteData = () => {
        const data = {
            T_BeneficiaryPlantationDetails_StatusInterCropsID: ShowDeletePopupData?.statusInterCropsID,
            M_TableUserMasterID: UserID,
            token: token,
            handleInterCropsDataIsPost
        }
        dispatch(StatusOfIntercropsDeleteAPI({ data }))
    }

    const { isDeleteLoading } = useSelector(state => state.StatusOfIntercropsDeleteData)

    return (
        <>
            {isFirstPartLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <div className="col-8 col-lg-12 pb-3 pt-4">
                {/* <div className="col-8 col-lg-6 pb-3 pt-4"> */}
                <CommonCircle />
                <span className="">Status of intercrops <AstricSign/>: </span>

                <span className=" add_button mx-3 px-3 py-1"
                    onClick={() => handleAddIntercrops()}
                >
                    {/* <i class="fa-solid fa-plus"></i>  */}
                     View
                </span>

                <StatusOfIntercropsDDL
                    StatusOfIntercropsId={StatusOfIntercropsId}
                    setStatusOfIntercropsId={setStatusOfIntercropsId}
                    apiFlag='StatusOfIntercrops'
                    Flag={Flag}
                    data={data}
                    IsPost=''
                />
                {/* </div> */}



                {/* {
                    StatusOfIntercropsId.ID == 83 ?
                        <div className="table-responsive p-0 tableFixHead" >
                            <table className="table table-bordered">
                                <thead>
                                    <tr className=" text-white">
                                      
                                        <th className="text-center">Name Of Crops</th>
                                        <th className="text-center">Action</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {

                                        StatusInterCropsData && StatusInterCropsData.length > 0 ? StatusInterCropsData.map((i, j) => {
                                            return (
                                                <>
                                                    {
                                                        i.isCheck == 1 ?
                                                            <tr>
                                                                
                                                                <td>{i.statusInterCrops ? i.statusInterCrops : '-'}</td>
                                                                <td align="center">

                                                                    <i className="fa fa-trash mx-2 text-danger v_icon_style"
                                                                        onClick={() => handleShowDelete(i)}
                                                                        title="Do you want to delete this record?"></i>
                                                                </td>

                                                            </tr>
                                                            :
                                                            <></>
                                                    }
                                                </>

                                            )
                                        })
                                            :
                                            <>No data found</>
                                    }
                                </tbody>
                            </table>

                        </div>
                        :
                        ''
                }

                {
                    StatusOfIntercropsId.ID == 84 ?
                        <div className="table-responsive p-0 tableFixHead" >
                            <table className="table table-bordered">
                                <thead>
                                    <tr className=" text-white">
                                       
                                        <th className="text-center">Name Of Crops</th>
                                        <th className="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {

                                        StatusInterCropsData && StatusInterCropsData.length > 0 ? StatusInterCropsData.map((i, j) => {
                                            return (

                                                <>
                                                    {
                                                        i.isCheck == 1 ?
                                                            <tr>
                                                               
                                                                <td>{i.statusInterCrops ? i.statusInterCrops : '-'}</td>
                                                                <td align="center">

                                                                    <i className="fa fa-trash mx-2 text-danger v_icon_style"
                                                                        onClick={() => handleShowDelete(i)}
                                                                        title="Do you want to delete this record?"></i>
                                                                </td>

                                                            </tr>
                                                            :
                                                            <></>

                                                    }
                                                </>
                                            )
                                        })
                                            :
                                            <>No data found</>
                                    }

                                </tbody>
                            </table>

                        </div>
                        :
                        ''
                } */}

            </div>


            {
                IntercropsPopup &&
                <StatusofintercropsPopup
                    handleAddIntercrops={handleAddIntercrops}
                    Title='Add Planting Time'
                    StatusOfIntercropsId={StatusOfIntercropsId}
                    InterCropsDataIsPost={InterCropsDataIsPost}
                    setInterCropsDataIsPost={setInterCropsDataIsPost}
                    M_BeneficiaryDetailsID={M_BeneficiaryDetailsID}
                    T_BeneficiaryPlantationDetailsID={T_BeneficiaryPlantationDetailsID}
                    Flag={Flag}
                    data={data}

                />
            }
            {
                ShowDeletePopup ?
                    <DeletePopUP
                        handleShowDelete={handleShowDelete}
                        ShowDeletePopupData={ShowDeletePopupData}
                        handleDeleteData={handleDeleteData}

                    /> : <></>
            }


        </>
    );
}

export default StatusOfIntercrops;